<template>
  <div class="child-profile-card-wrapper pa-3">
    <v-btn
      fab
      small
      class="child-profile-card-wrapper__remove"
      @click="$emit('remove', profile)"
    >
      <v-icon>close</v-icon>
    </v-btn>

    <v-card
      width="180"
      max-width="180"
      class="child-profile"
      :loading="loading"
      :disabled="!hasValidToken"
      :class="{ _active: isActiveProfile }"
      v-on="isActiveProfile ? null : $listeners"
    >
      <template v-slot:progress>
        <v-progress-linear
          color="green"
          indeterminate
          absolute
          top
        />
      </template>

      <v-img
        :src="profileAvatar"
        :aspect-ratio="1"
        :alt="profile.nickname"
      >
        <div class="child-profile__icons">
          <v-tooltip
            v-if="profile.school_id"
            top
            open-delay="250"
            color="grey darken-4"
          >
            <template v-slot:activator="{ on }">
              <div class="child-profile__icon _school">
                <img src="https://s3.amazonaws.com/images.growmindgrow/play-site/icons/school-icon.svg" alt="">
              </div>
            </template>
            <span>School Connected</span>
          </v-tooltip>
          <v-tooltip
            v-if="profile.parent_id"
            top
            open-delay="250"
            color="grey darken-4"
          >
            <template v-slot:activator="{ on }">
              <div class="child-profile__icon _parents">
                <img src="https://s3.amazonaws.com/images.growmindgrow/play-site/icons/parents-icon.svg" alt="parents">
              </div>
            </template>
            <span>Linked Profile</span>
          </v-tooltip>
          <v-tooltip
            v-if="!profile.parent_id && !profile.school_id"
            top
            open-delay="250"
            color="grey darken-4"
          >
            <template v-slot:activator="{ on }">
              <div class="child-profile__icon _lost" v-on="on">
                <AttentionIcon class="child-profile__icon-attention" />
              </div>
            </template>
            <span>Profile not linked</span>
          </v-tooltip>
        </div>
      </v-img>

      <v-toolbar
        height="72"
        color="#ffd600"
      >
        <div style="max-width: 100%">
          <v-toolbar-title>
            {{ profile.first_name }} {{ profile.last_name }}
          </v-toolbar-title>
          <div class="text-truncate">{{ profile.nickname }}</div>
        </div>
      </v-toolbar>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AttentionIcon from '@/components/icons/AttentionIcon';
import { AVATARS_FOLDER_URL } from '@/configs/urls';
import { findJWTByProfileId } from '@/helpers/auth';

export default {
  name: 'ProfileCard',
  components: { AttentionIcon },
  props: {
    profile: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('children', [
      'activeChildProfile',
    ]),
    isActiveProfile() {
      return this.profile.id === this.activeChildProfile?.id;
    },
    profileAvatar() {
      if (this.profile.avatar) {
        return AVATARS_FOLDER_URL + this.profile.avatar;
      }
      return AVATARS_FOLDER_URL + (this.profile.gender === 'boy' ? 'DefaultBoyProfile.png' : 'DefaultGirlProfile.png');
    },
    hasValidToken() {
      try {
        return !!findJWTByProfileId(this.$store.getters, this.profile.id);
      } catch {
        return false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.child-profile-card-wrapper {
  position: relative;

  &__remove {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
  }
}

.child-profile {
  transition: 0.2s;

  &:hover {
    box-shadow: 0px 7px 8px -4px rgba(0, 0, 0, 0.2), 0px 12px 17px 2px rgba(0, 0, 0, 0.14),
      0px 5px 22px 4px rgba(0, 0, 0, 0.12);
  }

  &._active {
    border: 2px solid #4caf50;
  }

  &::v-deep .v-card__progress {
    border-radius: unset !important;
  }

  &__icons {
    position: absolute;
    right: 0;
    bottom: 0;
  }

  &__icon {
    width: 35px;
    height: 35px;
    background-color: #4caf50;
    border-radius: 50%;
    right: -17px;
    z-index: 1;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;

    &._lost {
      background-color: transparent;
    }

    img {
      height: 24px;
    }

    &-attention {
      display: flex;
      justify-content: center;

      &::v-deep {
        svg {
          width: 75%;
        }
      }
    }
  }
}
</style>
